import { RiErrorWarningLine } from 'react-icons/ri';
import EmptyImage from '../assets/Warning.svg';
const ErrorEmptyStateView = ({
  title,
  description,
  type,
}) => (
  <div className="flex flex-col items-center justify-center py-8">
    {type === 'empty' ? (
      <img src={EmptyImage} alt="EmptyIcon" width={80} height={80} />
    ) : (
      <RiErrorWarningLine size={48} className="text-error-600" />
    )}
    <h3 className="mt-4 text-gray-900 font-medium text-lg">
      {title ?? (type === 'empty' ? 'No Data' : 'Something went wrong')}
    </h3>
    <p className="mt-2 text-gray-500 text-sm text-center max-w-[20rem]">
      {description ??
        (type === 'empty'
          ? 'We could not find any data. Please try again later.'
          : 'We are unable to process your request. Please try again later.')}
    </p>
  </div>
);

export default ErrorEmptyStateView;
